const getAssessmentReviewPageObject = (theme) => {
  return {
    subSectionHeadingContainer: {
      display: "flex",
      justifyContent: "space-between",
    },
    subSectionHeadingTextContainer: {
      display: "flex",
      gap: 20,
      alignItems: "flex-end",
      h2: {
        fontWeight: "400",
        fontSize: "20px",
        margin: 0,
        color: "black",
      },
    },
    subSectionInfoContainer: {
      display: "flex",
      gap: "4px",
      color: "#01579B",
      alignItems: "center",
      cursor: "pointer",
    },
    questionsContainer: {
      padding: "20px",
      borderRadius: "10px",
      backgroundColor: "white",
      margin: "20px 0px",
      border: "1px solid #0304041A",
    },
    questionsTextContainer: {
      display: "flex",
      // marginTop: "10px",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 20,
    },
    horizonalLine: {
      backgroundColor: "#0304041a",
      color: "#0304041a",
      borderColor: "#0304041a",
    },
    editButtonText: {
      color: "#0D47A1",
      fontWeight: "bold",
      fontSize: "14px",
    },
    assessmentReviewHeading: {
      textAlign: "center",
      padding: "20px 0px",
      fontSize: "30px",
    },
    bottomBar: {
      padding: "10px 30px",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
    },
    nextButtonActive: {
      backgroundColor: "#09306d",
      color: " white",
    },
    backButton: {
      borderColor: "#09306d",
      color: "#09306d",
    },
    bottomBarButton: {
      textTransform: "none",
      fontWeight: "bold",
      padding: "10px",
    },
  };
};

export const getAssessmentReviewPageStyle = getAssessmentReviewPageObject;
